<main class="container">
  <fieldset class="border rounded-3 p-3">
    <legend> </legend>
    <form [formGroup]="pittingInformationForm">
      <div style="display: flex">
        <div class="container">
          <div class="row">
            <div class="form-group col-sm-18 float-left">
              <label for="textBox1_DI_sngtmm"
                >Maximum pit depth, w_max&nbsp;<span *ngIf="this.intUnit === 0"
                  >(inch)</span
                ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
              >
              <input
                appRestrictInput
                type="number"
                formControlName="maximumPitDepth"
                (change)="onChangeTextBox1_DI($event)"
                id="textBox1_DI_sngtmm"
                class="form-control form-control-sm"
                min="0"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-18 float-left">
              <label for="textBox2_DI_sngdia_max"
                >Maximum pit diameter, dia_max&nbsp;<span
                  *ngIf="this.intUnit === 0"
                  >(inch)</span
                ><span *ngIf="this.intUnit === 1">(mm)</span>:</label
              >
              <input
                appRestrictInput
                type="number"
                formControlName="maximumPitDiameter"
                (change)="onChangeTextBox2_DI($event)"
                id="textBox2_DI_sngdia_max"
                class="form-control form-control-sm"
                min="0"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-18 float-left">
              <label for="comboBox1_DI"
                >Pitting and corrosion damage location:</label
              >

              <select
                id="comboBox1_DI"
                formControlName="damageLocation"
                class="form-control form-control-sm"
                (change)="onChangeComboBox1_DI($event)"
              >
                <option value="Initial" disabled selected hidden></option>
                <option value="0">Same side</option>
                <option value="1">Opposite sides</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-18 float-left">
              <label for="comboBox2_DI">Matching Pitting Chart:</label>
              <select
                id="comboBox2_DI"
                formControlName="pittingChart"
                class="form-control form-control-sm"
                (change)="onChangeComboBox2_DI($event)"
              >
                <option value="Initial" disabled selected hidden></option>
                <option *ngFor="let chart of charts; let i = index" [value]="i">
                  {{ chart }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <img alt="pitting_image" id="pitting_image" width="430px" height="430px" />
          </div>
        </div>
      </div>
    </form>
  </fieldset>
</main>
